// ============================================================
// Cart.jsx — Carrito de compras principal
// ============================================================
// ¿QUÉ HACE ESTE ARCHIVO?
//   - Muestra el ícono del carrito (flotante)
//   - Abre un modal con los productos agregados
//   - Permite cambiar cantidades y eliminar productos
//   - Si el cliente está logueado, muestra "Pedir por WhatsApp"
//   - Abre un segundo modal con el formulario del pedido
//   - Envía el pedido al servidor y abre WhatsApp
//
// PARA EDITAR COSAS COMUNES:
//   - Cambiar el texto del botón final  → busca "Finalizar pedido"
//   - Cambiar campos del formulario     → busca "FORMULARIO DEL PEDIDO"
//   - Cambiar opciones de entrega       → busca "OPCIONES DE ENTREGA"
//   - Cambiar zona horaria              → busca "ZONA HORARIA"
// ============================================================

import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import baseURL from '../url';
import './Cart.css';
import whatsappIcon from '../../images/wpp.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShoppingCart, faArrowLeft, faHome, faBoxOpen, faTrash, faPaperPlane } from '@fortawesome/free-solid-svg-icons';
import { faWhatsappSquare } from '@fortawesome/free-brands-svg-icons';
import { Link as Anchor } from "react-router-dom";
import moneda from '../moneda';
import Swal from 'sweetalert2';
import { ToastContainer, toast } from 'react-toastify';
// NOTA: MiPedido fue movido a Profile.jsx — ya no se usa aquí

export default function Cart() {

    // ── ESTADO: productos del carrito ────────────────────────
    const [cartItems, setCartItems] = useState([]);
    const [productos, setProductos] = useState([]);
    const [loading, setLoading]     = useState(true);

    // ── ESTADO: modal selector de cantidad por ítem ──────────
    const [isCartQtyModalOpen,  setIsCartQtyModalOpen]  = useState(false);
    const [selectedCartIndex,   setSelectedCartIndex]   = useState(null);
    const [isCartCustomQty,     setIsCartCustomQty]     = useState(false);
    const [cartCustomQtyValue,  setCartCustomQtyValue]  = useState('');

    // ── ESTADO: modales ──────────────────────────────────────
    const [modalIsOpen,   setModalIsOpen]   = useState(false); // Lista de productos
    const [modalIsOpen2,  setModalIsOpen2]  = useState(false); // Formulario pedido
    const [modalWhatsApp, setModalWhatsApp] = useState(false); // Contacto directo WA

    // ── ESTADO: formulario del pedido ────────────────────────
    const [isFocused,      setIsFocused]      = useState(false);
    const [noteText,       setNoteText]       = useState('');
    const [name,           setName]           = useState('');
    const [telefono,       setTelefono]       = useState('');
    const [address,        setAddress]        = useState('');
    const [codigo,         setCodigo]         = useState('');
    const [deliveryOption, setDeliveryOption] = useState('delivery');
    const [paymentMethod,  setPaymentMethod]  = useState('');
    const [pagoRecibir,    setPagoRecibir]    = useState('');

    // ── ESTADO: datos externos ───────────────────────────────
    const [tienda,  setTienda]  = useState([]);
    const [metodos, setMetodos] = useState([]);
    const [codigos, setCodigos] = useState([]);
    const [estado,  setEstado]  = useState(null); // 'Abierto' | 'Cerrado'

    // ── ESTADO: totales y descuento ──────────────────────────
    const [descuento,    setDescuento]    = useState(0);
    const [codigoValido, setCodigoValido] = useState(false);
    const [totalPrice,   setTotalPrice]   = useState(0);

    // ── ESTADO: plantilla mensaje WhatsApp ───────────────────
    const [plantillaMensaje, setPlantillaMensaje] = useState(null);

    // ── ESTADO: control de envío ─────────────────────────────
    const [mensaje,       setMensaje]       = useState('');
    const [pedidoEnviado, setPedidoEnviado] = useState(false);
    const [whatsappMessage, setWhatsappMessage] = useState('¡Hola! Estoy interesado en...');

    // ── ESTADO: cliente logueado ─────────────────────────────
    // El login/logout lo maneja NavbarCliente — aquí solo se lee
    const [cliente, setCliente] = useState(() => {
        const saved = localStorage.getItem('cliente');
        return saved ? JSON.parse(saved) : null;
    });

    // ── ZONA HORARIA ─────────────────────────────────────────
    // Colombia GMT-5 → offset = -5 * 60
    // Argentina GMT-3 → offset = -3 * 60
    let now          = new Date();
    let offset       = -5 * 60;
    let colombiaTime = new Date(now.getTime() + offset * 60 * 1000);
    let createdAt    = colombiaTime.toISOString().slice(0, 19).replace('T', ' ');

    // ────────────────────────────────────────────────────────
    // EFECTOS: carga inicial
    // ────────────────────────────────────────────────────────

    useEffect(() => {
        cargarTienda();
        if (localStorage.getItem('pedidoEnviado') === 'true') {
            setPedidoEnviado(true);
            localStorage.removeItem('pedidoEnviado');
        }
    }, []);

    useEffect(() => {
        fetch(`${baseURL}/mensaje-whatsapp.php`)
            .then(r => r.json())
            .then(data => { if (data?.ok && data?.data?.mensaje) setPlantillaMensaje(data.data.mensaje); })
            .catch(() => {});
    }, []);

    useEffect(() => {
        let total = 0;
        cartItems.forEach(item => { total += item.precio * item.cantidad; });
        setTotalPrice(total);
    }, [cartItems]);

    useEffect(() => {
        fetch(`${baseURL}/estado.php?`)
            .then(r => r.json())
            .then(data => { if (!data.error) setEstado(data.estado); })
            .catch(err => console.error('Error estado:', err));
    }, []);

    useEffect(() => { cargarMetodos(); cargarProductos(); }, [isFocused]);

    // Escucha cambios en localStorage desde otros componentes (Products, Detail)
    // para actualizar el contador del carrito en tiempo real sin recargar la página
    useEffect(() => {
        const handleStorage = () => {
            cargarProductos();
        };
        window.addEventListener('storage', handleStorage);
        return () => window.removeEventListener('storage', handleStorage);
    }, []);

    useEffect(() => {
        const fetchCartItems = async () => {
            const rawCart = JSON.parse(localStorage.getItem('cart')) || [];
            const cart = rawCart.map(c => ({ idProducto: c.idProducto, cantidad: c.cantidad, items: c.items || [] }));
            const promises = cart.map(async cartItem => {
                const producto = productos.find(p => p.idProducto === cartItem.idProducto);
                return { ...producto, cantidad: cartItem.cantidad, items: cartItem.items };
            });
            Promise.all(promises)
                .then(items => { setCartItems(items); setLoading(false); })
                .catch(err  => { console.error('Error carrito:', err); setLoading(false); });
        };
        fetchCartItems();
    }, [productos, isFocused]);

    useEffect(() => { if (metodos?.length > 0) setPaymentMethod(metodos[0].tipo); }, [metodos]);
    useEffect(() => { cargarCodigos(); }, []);

    // ────────────────────────────────────────────────────────
    // FUNCIONES: carga de datos
    // ────────────────────────────────────────────────────────

    const cargarTienda = () => {
        fetch(`${baseURL}/tiendaGet.php`)
            .then(r => r.json())
            .then(data => setTienda(data.tienda.reverse() || []))
            .catch(err => console.error('Error tienda:', err));
    };

    const cargarMetodos = () => {
        fetch(`${baseURL}/metodoGet.php`)
            .then(r => r.json())
            .then(data => setMetodos((data.metodos || []).filter(m => m.estado === 'Activo')))
            .catch(err => console.error('Error métodos:', err));
    };

    const cargarProductos = () => {
        fetch(`${baseURL}/productosGet.php`)
            .then(r => r.json())
            .then(data => setProductos(data.productos || []))
            .catch(err => console.error('Error productos:', err));
    };

    const cargarCodigos = () => {
        fetch(`${baseURL}/codigosGet.php`)
            .then(r => r.json())
            .then(data => setCodigos(data.codigos || []))
            .catch(err => console.error('Error códigos:', err));
    };

    // ────────────────────────────────────────────────────────
    // FUNCIONES: carrito
    // ────────────────────────────────────────────────────────

    // Guarda solo los campos mínimos para no saturar localStorage
    const persistCartToLocalStorage = (items) => {
        const minimal = (items || []).map(it => ({ idProducto: it.idProducto, cantidad: it.cantidad, items: it.items || [] }));
        localStorage.setItem('cart', JSON.stringify(minimal));
    };

    const removeFromCart = (id) => {
        const updated = cartItems.filter(item => item.idProducto !== id);
        setCartItems(updated);
        persistCartToLocalStorage(updated);
    };

    const clearCart = () => { setCartItems([]); localStorage.removeItem('cart'); };

    const obtenerImagen = (item) => item.imagen1 || item.imagen2 || item.imagen3 || item.imagen4 || null;

    // Comprime la imagen a thumbnail pequeño (100x100, 40% calidad)
    // Evita el error MySQL "Out of sort memory" al guardar pedidos
    const comprimirImagenAThumbnail = (base64, maxSize = 100, calidad = 0.4) => {
        return new Promise((resolve) => {
            if (!base64 || !base64.startsWith('data:')) { resolve(''); return; }
            const img = new Image();
            img.onload = () => {
                const canvas = document.createElement('canvas');
                const ratio = Math.min(maxSize / img.width, maxSize / img.height);
                canvas.width  = img.width  * ratio;
                canvas.height = img.height * ratio;
                canvas.getContext('2d').drawImage(img, 0, 0, canvas.width, canvas.height);
                resolve(canvas.toDataURL('image/jpeg', calidad));
            };
            img.onerror = () => resolve('');
            img.src = base64;
        });
    };

    // ────────────────────────────────────────────────────────
    // FUNCIONES: modales
    // ────────────────────────────────────────────────────────

    const openModal  = () => { setModalIsOpen(true);  setIsFocused(true);  };
    const closeModal = () => { setModalIsOpen(false); setIsFocused(false); };
    const openModal2  = () => setModalIsOpen2(true);
    const closeModal2 = () => setModalIsOpen2(false);
    const openWhatsAppModal  = () => setModalWhatsApp(true);
    const closeWhatsAppModal = () => setModalWhatsApp(false);

    // Pre-llena nombre y teléfono con los datos del cliente logueado
    const handleAbrirPedido = (clienteData) => {
        const c = clienteData || cliente;
        if (c) { setName(c.nombre); setTelefono(c.telefono || ''); setModalIsOpen2(true); }
    };

    // ────────────────────────────────────────────────────────
    // FUNCIONES: pagos
    // ────────────────────────────────────────────────────────

    const handlePaymentChange    = (metodo) => { setPaymentMethod(metodo); setPagoRecibir(metodo === 'Transferencia' ? 'Si' : ''); };
    const handlePagoRecibirChange = (value) => setPagoRecibir(value);

    // ────────────────────────────────────────────────────────
    // FUNCIÓN: WhatsApp directo (sin pedido)
    // ────────────────────────────────────────────────────────

    const sendWhatsAppMessage = () => {
        const url = `https://api.whatsapp.com/send?phone=${tienda[0]?.telefono}&text=${encodeURIComponent(whatsappMessage || 'Hola 👋')}`;
        window.open(url, '_blank');
        closeWhatsAppModal();
        setWhatsappMessage('¡Hola! Estoy interesado en...');
    };

    // ────────────────────────────────────────────────────────
    // FUNCIÓN: abrir WhatsApp con resumen del pedido ya guardado
    // ────────────────────────────────────────────────────────

    const handleWhatsappMessage = (data) => {
        const { idPedido, nombre, telefono, entrega, pago, codigo, total, nota, productos, pagoRecibir } = data;
        const formattedTotal    = total?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        const productosDetails  = productos.map(item => {
            const precio   = item?.precio?.toString()?.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
            const itemsFmt = Array.isArray(item?.items) ? item.items.join(', ') : (item?.items || '');
            return `\n✅ *${item.titulo}* \n      Precio: ${moneda} ${precio}  x  ${item?.cantidad ?? 1}\n      ${itemsFmt}\n`;
        }).join('');

        let message;
        if (plantillaMensaje) {
            // Usa la plantilla personalizada de la BD
            message = plantillaMensaje
                .replace(/{idPedido}/g,         String(idPedido))
                .replace(/{productosDetails}/g, productosDetails)
                .replace(/{nombre}/g,           String(nombre))
                .replace(/{telefono}/g,         String(telefono))
                .replace(/{entrega}/g,          String(entrega))
                .replace(/{pago}/g,             String(pago))
                .replace(/{pagoRecibir}/g,      String(pagoRecibir))
                .replace(/{codigo}/g,           String(codigo))
                .replace(/{nota}/g,             String(nota))
                .replace(/{moneda}/g,           String(moneda))
                .replace(/{total}/g,            formattedTotal);
        } else {
            // Formato por defecto si no hay plantilla
            message = `¡Hola! 🌟 Mi pedido es el N°${idPedido}\n${productosDetails}\n👤 Nombre: ${nombre}\n\n📱 Teléfono: ${telefono}\n\n📦 Entrega: ${entrega}\n\n💵 Forma de pago: ${pago}\n\n📌 Pago al recibirlo: ${pagoRecibir}\n\n🏷 Código: ${codigo}\n\n✅ Nota: ${nota}\n\n*Total: ${moneda} ${formattedTotal}*`;
        }

        window.open(`https://api.whatsapp.com/send?phone=${tienda[0]?.telefono}&text=${encodeURIComponent(message)}`, '_blank');
        setName(''); setNoteText(''); setCodigo('');
        setModalIsOpen(false); setModalIsOpen2(false);
    };

    // ────────────────────────────────────────────────────────
    // FUNCIÓN PRINCIPAL: guardar pedido en BD y enviar WhatsApp
    // ────────────────────────────────────────────────────────

    const crearPedido = async () => {
        if (pedidoEnviado) return;

        const resumen = cartItems.map(item => `• ${item.titulo} x${item.cantidad}`).join('\n');
        const confirm = await Swal.fire({
            title: '¿Confirmar pedido?',
            html:  `<pre style="text-align:left;font-size:14px;white-space:pre-wrap">${resumen}</pre>`,
            icon:  'question', showCancelButton: true,
            confirmButtonText: 'Sí, enviar', cancelButtonText: 'Revisar',
            confirmButtonColor: '#25D366',
        });
        if (!confirm.isConfirmed) return;

        setMensaje('Procesando...');
        try {
            // Comprimir imágenes a thumbnail antes de guardar en el pedido
            // Esto evita el error MySQL "Out of sort memory" con imágenes Base64 pesadas
            const productosPedido = await Promise.all(
                cartItems.map(async item => ({
                    idProducto:  item?.idProducto,
                    idCategoria: item?.idCategoria,
                    titulo:      item?.titulo,
                    cantidad:    item?.cantidad,
                    items:       item?.items,
                    precio:      item?.precio,
                    imagen:      await comprimirImagenAThumbnail(obtenerImagen(item)),
                }))
            );

            let total = 0;
            cartItems.forEach(item => { total += item?.precio * item?.cantidad; });

            const formData = new FormData();
            formData.append('productos',   JSON.stringify(productosPedido));
            formData.append('total',       total);
            formData.append('nombre',      name);
            formData.append('telefono',    telefono);
            formData.append('entrega',     deliveryOption === 'delivery' ? address : 'Retiro en Sucursal');
            formData.append('pago',        paymentMethod);
            formData.append('nota',        noteText);
            formData.append('codigo',      codigo);
            formData.append('estado',      'Pendiente');
            formData.append('pagado',      'No');
            formData.append('pagoRecibir', pagoRecibir);
            formData.append('createdAt',   createdAt);
            // Asocia el pedido al cliente si está logueado
            if (cliente?.idCliente) formData.append('idCliente', cliente.idCliente);

            const response = await fetch(`${baseURL}/pedidoPost.php`, { method: 'POST', body: formData });
            const data     = await response.json();

            if (data.idPedido) {
                setMensaje('');
                Swal.fire('Pedido enviado!', `Pedido N°${data.idPedido} creado con éxito.`, 'success');
                handleWhatsappMessage(data);
                localStorage.setItem('idPedido', data.idPedido);
                setPedidoEnviado(true);
                localStorage.setItem('pedidoEnviado', 'true');
                setName(''); setCodigo(''); setNoteText('');
                closeModal(); closeModal2(); clearCart();
            } else if (data?.error) {
                setMensaje('');
                Swal.fire('Error', data?.error, 'error');
            }
        } catch (error) {
            console.error('Error al crear pedido:', error);
            setMensaje('');
            Swal.fire('Error', 'Error de conexión. Por favor, inténtelo de nuevo.', 'error');
        }
    };

    // ────────────────────────────────────────────────────────
    // RENDER
    // ────────────────────────────────────────────────────────

    return (
        <div>
            <ToastContainer />

            {/* ── Ícono flotante del carrito ────────────────────── */}
            <button onClick={openModal} className='cartIconFixed'>
                {cartItems?.length >= 1 && <span>{cartItems.length}</span>}
                <FontAwesomeIcon icon={faShoppingCart} />
            </button>

            {/* ── Barra inferior (solo mobile) ──────────────────── */}
            {/* Para editar los ítems de esta barra, modifica aquí  */}
            <div className="bottom-nav-bar">
                <Anchor to="/" className="nav-item" onClick={closeModal}>
                    <FontAwesomeIcon icon={faHome} size="lg" /><span>Inicio</span>
                </Anchor>
                <button onClick={openWhatsAppModal} className="nav-item whatsapp-item">
                    <FontAwesomeIcon icon={faWhatsappSquare} size="2x" /><span>Business</span>
                </button>
                <button onClick={openModal} className="nav-item cart-item">
                    <FontAwesomeIcon icon={faShoppingCart} size="lg" />
                    {cartItems?.length >= 1 && <div className="cart-counter">{cartItems.length}</div>}
                    <span>Carrito</span>
                </button>
                <Anchor to="/productos" className="nav-item" onClick={closeModal}>
                    <FontAwesomeIcon icon={faBoxOpen} size="lg" /><span>Productos</span>
                </Anchor>
            </div>

            {/* ════════════════════════════════════════════════════
                MODAL: Contacto directo WhatsApp (sin hacer pedido)
                ════════════════════════════════════════════════════ */}
            <Modal isOpen={modalWhatsApp} className="modal-cart" overlayClassName="overlay-cart" onRequestClose={closeWhatsAppModal}>
                <div className='deFLex'>
                    <button onClick={closeWhatsAppModal}><FontAwesomeIcon icon={faArrowLeft} /></button>
                    <h4>Contactar por WhatsApp</h4>
                    <div />
                </div>
                <div className="modal-send-form" style={{ justifyContent: 'space-between' }}>
                    <div>
                        <div style={{ backgroundColor: '#f0f0f0', padding: '15px', borderRadius: '10px', marginBottom: '20px' }}>
                            <p style={{ margin: '0', color: '#333' }}>Hola, ¿en qué podemos ayudarte? 👋</p>
                        </div>
                        <textarea value={whatsappMessage} onChange={e => setWhatsappMessage(e.target.value)}
                            placeholder="Escribe tu mensaje..."
                            style={{ width: '100%', minHeight: '120px', border: '1px solid #ddd', borderRadius: '8px', padding: '10px', fontSize: '16px', resize: 'vertical' }} />
                    </div>
                    <button onClick={sendWhatsAppMessage} className='btn' style={{ backgroundColor: '#25D366' }}>
                        Enviar Mensaje <FontAwesomeIcon icon={faPaperPlane} />
                    </button>
                </div>
            </Modal>

            {/* ════════════════════════════════════════════════════
                MODAL PRINCIPAL: Lista de productos del carrito
                ════════════════════════════════════════════════════ */}
            <Modal isOpen={modalIsOpen} className="modal-cart" overlayClassName="overlay-cart" onRequestClose={closeModal}>

                {/* Header — "Ver mi pedido" fue removido y movido a Profile.jsx */}
                <div className='deFLex'>
                    <button onClick={closeModal}><FontAwesomeIcon icon={faArrowLeft} /></button>
                    <h4>Mi carrito</h4>
                    <div />
                </div>

                {estado === 'Abierto' ? (
                    <>
                        {cartItems?.length === 0 ? (
                            <p className='nohay'>No hay productos</p>
                        ) : (
                            <>
                                {/* ── Lista de productos ──────────────────── */}
                                <div className="modal-content-cart">
                                    {loading ? <p>Cargando...</p> : (
                                        <div>
                                            {cartItems.map((item, index) => (
                                                <div key={item?.idProducto} className='cardProductCart'>
                                                    <Anchor to={`/producto/${item?.idProducto}/${item?.titulo?.replace(/\s+/g, '-')}`} onClick={closeModal}>
                                                        <img src={obtenerImagen(item)} alt="imagen" loading="lazy" />
                                                    </Anchor>
                                                    <div className='cardProductCartText'>
                                                        <h3>{item.titulo}</h3>
                                                        <span>{item?.items?.map((sabor, i) => <span key={i}>{sabor}, </span>)}</span>
                                                        <strong>{moneda} {item?.precio?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')}</strong>
                                                    </div>
                                                    <div className='deColumn'>
                                                        <button onClick={() => removeFromCart(item.idProducto)} className='deleteCart'>
                                                            <FontAwesomeIcon icon={faTrash} />
                                                        </button>
                                                        <div className='deFlexCantidad'>
                                                            {/* Toca aquí para cambiar la cantidad */}
                                                            <button type="button" className="qtyRowMini"
                                                                onClick={() => {
                                                                    const stock = Number(item?.stock) || 0;
                                                                    if (stock <= 0) { toast.error('No hay stock', { autoClose: 600 }); return; }
                                                                    setSelectedCartIndex(index);
                                                                    setIsCartQtyModalOpen(true);
                                                                    setIsCartCustomQty(false);
                                                                    setCartCustomQtyValue(String(item.cantidad || 1));
                                                                }}>
                                                                <span>
                                                                    Cantidad: <strong>{item.cantidad}</strong>{' '}
                                                                    <span className="qtyRowHint">
                                                                        (+{Math.max((Number(item?.stock) || 0) - (Number(item?.cantidad) || 0), 0)} disponibles)
                                                                    </span>
                                                                </span>
                                                                <span className="qtyRowRight">›</span>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>

                                {/* ── Total y botón de pedido ─────────────── */}
                                <div className='deColumnCart'>
                                    <h4>Total: {moneda} {totalPrice?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')}</h4>
                                    <div className='deFLexBtns'>
                                        {/* Logueado → botón de pedido | No logueado → aviso */}
                                        {cliente ? (
                                            <button className='btnWpp' onClick={() => handleAbrirPedido()}>
                                                Pedir por WhatsApp <img src={whatsappIcon} alt="WhatsApp" />
                                            </button>
                                        ) : (
                                            <p className='cart-login-aviso'>
                                                🔒 Inicia sesión desde el menú para poder realizar tu pedido.
                                            </p>
                                        )}
                                    </div>
                                </div>

                                {/* ════════════════════════════════════════
                                    MODAL FORMULARIO DEL PEDIDO
                                    Agrega / quita campos editando aquí
                                    ════════════════════════════════════════ */}
                                <Modal isOpen={modalIsOpen2} onRequestClose={closeModal2} className="modal-cart" overlayClassName="overlay-cart">
                                    <div className='deFLex'>
                                        <button onClick={closeModal2}><FontAwesomeIcon icon={faArrowLeft} /></button>
                                        <h4>(*) Campos obligatorios</h4>
                                    </div>
                                    <div className="modal-send-form">

                                        {/* ── Datos personales ──────────────── */}
                                        <input type="text" id="name" value={name}
                                            onChange={e => setName(e.target.value)} placeholder='Apellido y Nombre (*)' />
                                        <input type="number" id="telefono" value={telefono}
                                            onChange={e => setTelefono(e.target.value)} placeholder='Teléfono / WhatsApp (*)' />

                                        {/* ── OPCIONES DE ENTREGA ───────────── */}
                                        {/* Para agregar una opción: copia uno de los bloques <div> */}
                                        <div className='deFLexRadio'>
                                            <label>Opciones de entrega (*)</label>
                                            <div onClick={() => setDeliveryOption('delivery')}>
                                                <input type="radio" id="delivery" name="deliveryOption" value="delivery"
                                                    checked={deliveryOption === 'delivery'} onChange={() => setDeliveryOption('delivery')} />
                                                <label htmlFor="delivery">Envío a domicilio</label>
                                            </div>
                                            <div onClick={() => setDeliveryOption('pickup')}>
                                                <input type="radio" id="pickup" name="deliveryOption" value="pickup"
                                                    checked={deliveryOption === 'pickup'} onChange={() => setDeliveryOption('pickup')} />
                                                <label htmlFor="pickup">Retiro en Sucursal</label>
                                            </div>
                                            <div onClick={() => setDeliveryOption('digital')}>
                                                <input type="radio" id="digital" name="deliveryOption" value="digital"
                                                    checked={deliveryOption === 'digital'} onChange={() => setDeliveryOption('digital')} />
                                                <label htmlFor="digital">Envío Digital/Online</label>
                                            </div>
                                        </div>

                                        {/* Campo dirección, solo si elige "Envío a domicilio" */}
                                        {deliveryOption === 'delivery' && (
                                            <input type="text" id="address" name="address" value={address}
                                                onChange={e => setAddress(e.target.value)} placeholder="Dirección / Nro. (*)" />
                                        )}

                                        {/* ── FORMAS DE PAGO ────────────────── */}
                                        {/* Se generan dinámicamente desde la BD */}
                                        <div className='deFLexRadio'>
                                            <label>Formas de pago (*)</label>
                                            {metodos?.map(metodo => (
                                                <section key={metodo.idMetodo} className='columnRadio'>
                                                    <div>
                                                        <input type="radio" name="paymentMethod" id={metodo.tipo}
                                                            value={metodo.tipo} checked={paymentMethod === metodo.tipo}
                                                            onChange={() => handlePaymentChange(metodo.tipo)} />
                                                        <label htmlFor={metodo.tipo}>{metodo.tipo}</label>
                                                    </div>
                                                    {/* Sub-opción solo para Transferencia */}
                                                    {paymentMethod === 'Transferencia' && metodo.tipo === 'Transferencia' && (
                                                        <section className='radioRecibi'>
                                                            <label>Pago al recibirlo</label>
                                                            <div>
                                                                <input type="radio" name="pagoRecibir" id="Si" value="Si"
                                                                    checked={pagoRecibir === 'Si'} onChange={() => handlePagoRecibirChange('Si')} />
                                                                <label htmlFor="Si">Sí</label>
                                                            </div>
                                                            <div>
                                                                <input type="radio" name="pagoRecibir" id="No" value="No"
                                                                    checked={pagoRecibir === 'No'} onChange={() => handlePagoRecibirChange('No')} />
                                                                <label htmlFor="No">No (envío comprobante)</label>
                                                            </div>
                                                        </section>
                                                    )}
                                                </section>
                                            ))}
                                        </div>

                                        {/* Datos bancarios del método seleccionado (ej: CBU, alias) */}
                                        {metodos?.length > 0 && metodos?.some(m => m.tipo === paymentMethod) && (
                                            <>
                                                {metodos.filter(m => m.tipo === paymentMethod).map(datos => (
                                                    datos?.datos !== '' && (
                                                        <div className='deFLexRadioMetod' key={datos.idDatos}>
                                                            <span>{datos.datos}</span>
                                                        </div>
                                                    )
                                                ))}
                                            </>
                                        )}

                                        {/* ── Código de descuento ───────────── */}
                                        <input type="text" id="codigo" value={codigo}
                                            onChange={e => setCodigo(e.target.value)} placeholder='Código de descuento (opcional)' />

                                        {/* ── Nota del pedido ───────────────── */}
                                        <textarea placeholder="Agrega aquí detalles o solicitudes del pedido (Opcional)"
                                            value={noteText} onChange={e => setNoteText(e.target.value)} />

                                        {/* Campo oculto con lista de productos */}
                                        <fieldset className='deNonefieldset'>
                                            <legend>Productos</legend>
                                            <textarea name='productos' readOnly
                                                value={cartItems.map(item =>
                                                    `${item.titulo}, x ${item.cantidad}, ${item.items}, ${item.precio}, ${obtenerImagen(item)}`
                                                ).join('\n')} />
                                        </fieldset>
                                    </div>

                                    {/* ── Botón final ───────────────────────── */}
                                    {mensaje ? (
                                        <button type='button' className='btn' disabled>{mensaje}</button>
                                    ) : pedidoEnviado ? (
                                        <button type='button' className='btn' disabled style={{ backgroundColor: '#aaa' }}>✅ Pedido ya enviado</button>
                                    ) : (
                                        <button type='button' onClick={crearPedido} className='btn'>
                                            Finalizar pedido <img src={whatsappIcon} alt="WhatsApp" />
                                        </button>
                                    )}
                                </Modal>
                                {/* FIN MODAL FORMULARIO DEL PEDIDO */}

                            </>
                        )}
                    </>
                ) : (
                    <p className='nohay'>El establecimiento se encuentra <br />cerrado en estos momentos. <br />Consulte por horarios de atención.</p>
                )}

                {/* ════════════════════════════════════════════════════
                    MODAL: Selector de cantidad
                    Se abre al tocar "Cantidad: X" en un producto
                    ════════════════════════════════════════════════════ */}
                <Modal open={isCartQtyModalOpen} onClose={() => setIsCartQtyModalOpen(false)} center classNames={{ modal: 'custom-modal' }}>
                    <h2 style={{ marginTop: 0 }}>Elige cantidad</h2>
                    {selectedCartIndex !== null && (() => {
                        const item         = cartItems[selectedCartIndex];
                        const stock        = Number(item?.stock) || 0;
                        const MAX_QUICK    = 10;
                        const quickOptions = Array.from({ length: Math.min(stock, MAX_QUICK) }, (_, i) => i + 1);
                        return (
                            <div>
                                <div className="qtyList">
                                    {quickOptions.map(n => (
                                        <button key={n} type="button" className="qtyListItem"
                                            onClick={() => {
                                                const updated = [...cartItems];
                                                updated[selectedCartIndex] = { ...updated[selectedCartIndex], cantidad: n };
                                                setCartItems(updated); persistCartToLocalStorage(updated); setIsCartQtyModalOpen(false);
                                            }}>
                                            {n} {n === 1 ? 'unidad' : 'unidades'}
                                        </button>
                                    ))}
                                    {stock > MAX_QUICK && (
                                        <button type="button" className="qtyListItem" onClick={() => setIsCartCustomQty(true)}>
                                            Más de {MAX_QUICK} unidades
                                        </button>
                                    )}
                                </div>
                                {isCartCustomQty && (
                                    <div style={{ marginTop: 14 }}>
                                        <label style={{ display: 'block', marginBottom: 6 }}>Ingresa cantidad (máx. {stock})</label>
                                        <input type="number" min={1} value={cartCustomQtyValue}
                                            onChange={e => setCartCustomQtyValue(e.target.value)}
                                            style={{ width: '100%', padding: 10, borderRadius: 8 }} />
                                        <button type="button" style={{ width: '100%', marginTop: 10, padding: 10, borderRadius: 8 }}
                                            onClick={() => {
                                                let val = Number(cartCustomQtyValue);
                                                if (!Number.isFinite(val) || val < 1) val = 1;
                                                if (val > stock) { val = stock; toast.info(`Máximo disponible: ${stock}`, { autoClose: 600 }); }
                                                const updated = [...cartItems];
                                                updated[selectedCartIndex] = { ...updated[selectedCartIndex], cantidad: val };
                                                setCartItems(updated); persistCartToLocalStorage(updated); setIsCartQtyModalOpen(false);
                                            }}>
                                            Confirmar
                                        </button>
                                    </div>
                                )}
                            </div>
                        );
                    })()}
                </Modal>
                {/* FIN MODAL SELECTOR DE CANTIDAD */}

            </Modal>
            {/* FIN MODAL PRINCIPAL DEL CARRITO */}

        </div>
    );
}
